import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactDatatable from "@ashvin27/react-datatable";
import { convertCoin } from "../../../actions/accountActions";
import axios from "axios";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
// import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// import "react-toastify/dist/ReactToastify.css";
import * as myConstList from "../../../BaseUrl";
import { Modal } from "react-bootstrap";
import {toast,Toaster} from "react-hot-toast"

const baseUrl = myConstList.baseUrl;
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};
class AccountList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      records: [],
      email: "",
      currency: "",
      walletAddress: "",
      remarks: "",
      redeemeTableData: [],
      userTotalPoints: 0,
      isRedeemModal: false,
      message: "",
      isModalOpen: false,
      showResults: false,
      isWithdrawalModal: false,
      urltemp: "",
      convertCoinAmount:0,
      convrtPoints:0,
      convrtPointsId:"",
      showConfirmation:false,
      errors: {},
    };

    this.columns = [
      {
        key: "id",
        text: "Id",
        className: "id",
        align: "left",
        sortable: true,
        cell: (row, index) => index + 1,
      },
      {
        key: "coin_name",
        text: "Coin Name",
        className: "amount",
        align: "left",
        sortable: true,
      },
      {
        key: "coin_amount",
        text: "Coin Amount",
        className: "txStatus",
        align: "left",
        sortable: true,
      },
      {
        key: "coin_points",
        text: "Points",
        className: "Currency",
        align: "left",
        sortable: true,
        cell: (record) => {
          var coin_points = record.coin_amount * record.coinPoints;
          return <Fragment>{coin_points}</Fragment>;
        },
      },
      {
        key: "",
        text: "Actions",
        className: "Currency",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              <button
                className="btn btn_man"
                onClick={() => this.convertCoin(record)}
                style={{ marginRight: "5px" }}
              >
                Convert
              </button>
              <button
                className="btn btn_man"
                onClick={() => this.withdrawalCoin(record)}
              >
                Withdrawal
              </button>
            </Fragment>
          );
        },
      },
    ];

    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "Fund Request List",
      no_data_text: "No user found!",
      button: {
        print: true,
        csv: true,
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };
    this.getData = this.getData5.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.account !== undefined &&
      nextProps.account.account !== undefined &&
      nextProps.account.account.data !== undefined &&
      nextProps.account.account.data.data !== undefined &&
      nextProps.account.account.data.message !== undefined &&
      nextProps.account.account.data.success
    ) {
      this.setState({
        message: nextProps.account.account.data.message,
        errors: {},
        currency: "",
        walletAddress: "",
        remarks: "",
        convertedPoints: "",
        totalPoints: "",
        name: "",
        isModalOpen: false,
        points: "",
        error: "",
      });
      this.getTotalPoints();
      this.getData5();
    }
  }

  componentDidMount() {
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
    this.getData5();
    this.getTotalPoints();
  }
  getData5() {
    axios
      .post(baseUrl + "api/user-coin-data", {}, configToken)
      .then((res) => {
        this.setState({ records: res.data.data });
      })
      .catch();
  }
  onChange = (e) => {
    this.setState({
      message: "",
      errors: {
        email: "",
      },
    });

    if (e.target.id === "user-update-email") {
      this.setState({ email: e.target.value });
    }
    if (e.target.id === "wallet_address") {
      this.setState({ walletAddress: e.target.value });
    }
    if (e.target.id === "coin_amount") {
      this.setState({ withdrawalAmount: e.target.value });
    }
    if (e.target.id === "user-update-remarks") {
      this.setState({ remarks: e.target.value, showResults: true });
    }
    if (e.target.id === "convertedPoints") {
      console.log("datatMupliplet===",e.target.value,' * ',this.state.points);
      var totalCoins = e.target.value * this.state.points;
      this.setState({
        totalPoints: totalCoins,
        convertedPoints: e.target.value,
      });
    }
  };

  convertCoin = (record) => {
    let coin_id = record.coins_id;
    this.setState({ isModalOpen: true ,convertCoinAmount:record.coin_amount});
    let data = {
      coin_id: coin_id,
    };
    axios
      .post(baseUrl + "api/get-coin-details", data, configToken)
      .then((res) => {
        var resp = res.data;
        if (resp.success === true) {
          this.setState({
            coinsrecord: resp.data,
            coin_id: resp.data.id,
            name: resp.data.coins_name,
            points: resp.data.coins_points,
          });
        }
      });
  };
  withdrawalCoin = (data) => {
    this.setState({ isWithdrawalModal: true, withdrawalCoinId: data.coins_id });
  };
  onRedeemeCoins = (point,id) => {
    // console.log(point);
    let data = {
      points: point,
      voucherId:id
    };
    axios.post(baseUrl + "api/redeeme-coins", data, configToken).then((res) => {
      var resp = res.data;
      if (resp.success === true) {
        this.getTotalPoints();
        this.setState({ isRedeemModal: false });
      }
    });
  };
  withdrawalAmount = () => {
    let data = {
      coin_amount: this.state.withdrawalAmount,
      wallet_address: this.state.walletAddress,
      coin_id: this.state.withdrawalCoinId,
    };
    axios
      .post(baseUrl + "api/withdrawal-user", data, configToken)
      .then((res) => {
        var resp = res.data;
        if (resp.success === true) {
          toast.success(resp.message, toastStyles);
          this.setState({ isWithdrawalModal: false });
          this.getData5();
        }else{
          toast.error(resp.message)
        }
      });
  };
  redeemTableHtml = () => {
    const html = [];
    if (this.state.redeemeTableData.length > 0) {
      this.state.redeemeTableData.map((item, i) => {
        return html.push(
          <tr>
            <td>{i + 1}</td>
            <td>{item.name}</td>
            <td>{item.point_required}</td>
            <td>
              <button
                className="btn btn_man"
                onClick={() => this.confirmBox(item.point_required,item.id)}
              >
                Redeem
              </button>
            </td>
          </tr>
        );
      });
    } else {
      html.push(
        <tr>
          <td colSpan={4} align="center">
            No Record Found
          </td>
        </tr>
      );
    }
    return <tbody>{html}</tbody>;
  };
  confirmBox = (points,id) => {
    this.setState({ isRedeemModal: false });
      confirmAlert({
        title: "Confirm to submit",
        message: "Really want to redeeme points?",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.onRedeemeCoins(points,id),
          },
          {
            label: "No",
            onClick: () => {
              this.setState({ isRedeemModal: true });
            },
          },
        ],
      });
    // this.setState({ isRedeemModal: false,showConfirmation:true,convrtPoints:points,convrtPointsId:id });
  };

  pageChange(pageData) {
    // console.log("OnPageChange", pageData);
  }
  closeModal = () => {
    this.setState({
      isModalOpen: false,
      isRedeemModal: false,
      isWithdrawalModal: false,
      showConfirmation: false,
    });
  };
  onCountryAdd = (e) => {
    e.preventDefault();
    if(this.state.convertCoinAmount < this.state.convertedPoints){
      toast.error("You have no sufficient Coins");
      return false;
    }
    const newCountry = {
      id: this.state.coin_id,
      convertedPoints: this.state.convertedPoints,
      givienPoints: this.state.totalPoints,
    };
    this.props.convertCoin(newCountry, this.props.history);
  };
  openRedeemModal = () => {
    let data = {
      userPoints: this.state.userTotalPoints,
    };
    axios.post(baseUrl + "api/get-offer-details", data).then((res) => {
      var resp = res.data;
      if (resp.success === true) {
        this.setState({ redeemeTableData: resp.data });
      } else {
        this.setState({ redeemeTableData: [] });
      }
    });
    this.setState({ isRedeemModal: true });
  };
  getTotalPoints = () => {
    axios
      .post(baseUrl + "api/user-total-points", {}, configToken)
      .then((res) => {
        var resp = res.data;
        if (resp.success === true) {
          this.setState({ userTotalPoints: resp.data.totalPoints });
        } else {
        }
      });
  };
  render() {
    return (
      <div className="container container2">
              <h1 className="h3 white_box">Points Wallet</h1>
        <div className="white_box">
          <div className="mb-2">
            <button
              className="btn btn_man float-right"
              onClick={this.openRedeemModal}
            >
              Redeem
            </button>
          </div>
          <div className="mb-2">
            <h5>Total points:--{this.state.userTotalPoints}</h5>
          </div>
          <h5 class=" mb-3">Coins List</h5>
          <div className="ccrool_table">
            <ReactDatatable
              config={this.config}
              records={this.state.records}
              columns={this.columns}
              onPageChange={this.pageChange.bind(this)}
            />
          </div>
          {/* Convert Modal Start */}
          <Modal show={this.state.isModalOpen} onHide={this.closeModal}>
            <Modal.Header>
              <Modal.Title> Convert Coin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-body">
                <form noValidate onSubmit={this.onCountryAdd} id="add-user">
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label htmlFor="name">Coin Name</label>
                      <p className="m-0">
                        <b>{this.state.name}</b>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="points">Coin Points Value</label>
                      <p className="m-0">
                        <b>{this.state.points}</b>
                      </p>
                    </div>
                    <div className="col-md-7">
                      <label htmlFor="points">Coin Points Value</label>
                      <input
                        className="form-control"
                        value={this.state.convertedPoints}
                        id="convertedPoints"
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="col-md-5">
                      <p className="m-0">You will recive</p>
                      <p className="m-0">
                        <b>{this.state.totalPoints}</b>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={this.closeModal}
                >
                  Close
                </button>
                <button
                  form="add-user"
                  type="submit"
                  className="btn btn-primary"
                >
                  Convert
                </button>
              </div>
            </Modal.Body>
          </Modal>
          {/* Convert Modal End */}

          {/* Redeem Modal Start */}
          <Modal show={this.state.isRedeemModal} onHide={this.closeModal}>
            <Modal.Header>
              <Modal.Title> Reedem Points</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <table className="table w-100">
                <thead>
                  <th>Sr No.</th>
                  <th>Redeem Offer</th>
                  <th>Required Points</th>
                  <th>Action</th>
                </thead>
                {this.redeemTableHtml()}
              </table>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={this.closeModal}
                >
                  Close
                </button>
              </div>
            </Modal.Body>
          </Modal>
          {/* Redeem Modal End */}

          {/* Withdrawal Modal Start */}
          <Modal show={this.state.isWithdrawalModal} onHide={this.closeModal}>
            <Modal.Header>
              <Modal.Title> Withdrawal Coins</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <lable>Coin Amount</lable>
                <input
                  type={"text"}
                  className="form-control"
                  id="coin_amount"
                  onChange={this.onChange}
                  value={this.state.withdrawalAmount}
                />
                <lable>Wallet Address</lable>
                <input
                  type={"text"}
                  className="form-control"
                  id="wallet_address"
                  onChange={this.onChange}
                  value={this.state.walletAddress}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={this.closeModal}
                >
                  Close
                </button>
                <button
                  form="add-user"
                  type="submit"
                  className="btn btn_man"
                  onClick={this.withdrawalAmount}
                >
                  Withdrawal
                </button>
              </div>
            </Modal.Body>
          </Modal>
          {/* Withdrawal Modal End */}

          {/* Redeem modal */}
          <Modal show={this.state.showConfirmation} onHide={this.closeModal}>
            <Modal.Header>
              <Modal.Title> Confirm to submit <br/>Really want to redeeme points?</Modal.Title>
            </Modal.Header>
            <Modal.Body>              
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={this.onRedeemeCoins(this.state.convrtPoints,this.state.convrtPointsId)}
                >
                  Yes
                </button>
                <button
                  form="add-user"
                  type="submit"
                  className="btn btn_man"
                  onClick={this.closeModal}
                >
                  Close
                </button>
              </div>
            </Modal.Body>
          </Modal>
          {/* Redeem modal */}
        </div>
      </div>
    );
  }
}

AccountList.propTypes = {
  convertCoin: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  account: state.account,
  errors: state.errors,
});

export default connect(mapStateToProps, { convertCoin })(
  withRouter(AccountList)
);
